<template lang="pug">
v-card
    v-card-title Community Filters
    v-card-text
        v-container.holder
            v-card(:loading="loading")
                v-card-text
                    v-row
                        v-col(cols="6")
                            v-text-field(label="User Followed Artists" v-model="form.user_followed_artists.number_of_songs" :disabled="loading")
                        v-col(cols="6")
                            v-text-field(v-model="form.user_followed_artists.option_value")
                    v-row
                        v-col(cols="6")
                            v-text-field(label="User Defined Genre" v-model="form.user_followed_defined_genre.number_of_songs" :disabled="loading")
                        v-col(cols="6")
                            v-text-field(v-model="form.user_followed_defined_genre.option_value")
                    v-row
                        v-col(cols="6")
                            v-text-field(label="System Defined Genre" v-model="form.system_defined_genre.number_of_songs" :disabled="loading")
                        v-col(cols="6")
                            v-text-field(v-model="form.system_defined_genre.option_value")
                v-card-actions
                    v-spacer
                    v-btn(color="primary" @click="onSubmit" :disabled="loading") Update

    v-snackbar(v-model="success" top color="green")
        v-icon(left) mdi-alert-circle-outline
        | Successfully Saved!
        template(v-slot:action="{ attrs }")
            v-btn(
                color="white"
                text
                v-bind="attrs"
                @click="success = false"
            ) Close

    v-snackbar(v-model="error.show" top color="red")
        v-icon(left) mdi-alert-circle-outline
        | {{ error.message }}
        template(v-slot:action="{ attrs }")
            v-btn(
                color="white"
                text
                v-bind="attrs"
                @click="error.show = false"
            ) Close
        
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    data() {
        return {
            success: false,
            loading: true,
            error: {
                show: false,
                message: ''
            },
            form: {
                user_followed_artists: {
                    option_value: null,
                    number_of_songs: null
                },
                user_followed_defined_genre: {
                    option_value: null,
                    number_of_songs: null
                },
                system_defined_genre: {
                    option_value: null,
                    number_of_songs: null
                }
            }
        };
    },
    computed: {
        ...mapGetters('bh-songlisting-options', { settings: 'find' })
    },
    async created() {
        await this.getSettings({
            query: {
                option_description: { $in: ['user_followed_artists', 'user_followed_defined_genre', 'system_defined_genre'] }
            }
        });

        this.form.user_followed_artists.option_value = this.getOptions('user_followed_artists').option_value;
        this.form.user_followed_artists.number_of_songs = this.getOptions('user_followed_artists').number_of_songs;

        this.form.user_followed_defined_genre.option_value = this.getOptions('user_followed_defined_genre').option_value;
        this.form.user_followed_defined_genre.number_of_songs = this.getOptions('user_followed_defined_genre').number_of_songs;

        this.form.system_defined_genre.option_value = this.getOptions('system_defined_genre').option_value;
        this.form.system_defined_genre.number_of_songs = this.getOptions('system_defined_genre').number_of_songs;

        this.loading = false;
    },
    methods: {
        getOptions(option_description) {
            const settings = this.settings({
                query: { option_description }
            });
            return settings.data[0];
        },
        async updateSettings(option_description, value) {
            const settings = this.getOptions(option_description);
            settings.option_value = value.option_value;
            settings.number_of_songs = value.number_of_songs;
            await settings.patch();
        },
        async onSubmit() {
            try {
                this.loading = true;
                
                await this.updateSettings('user_followed_artists', this.form.user_followed_artists);
                await this.updateSettings('user_followed_defined_genre', this.form.user_followed_defined_genre);
                await this.updateSettings('system_defined_genre', this.form.system_defined_genre);

                this.success = true;
            } catch(err) {
                this.error.message = err.message;
                this.error.show = true;
            } finally {
                this.loading = false;
            }
        },
        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        ...mapActions('bh-songlisting-options', { getSettings: 'find' })
    }
}
</script>

<style lang="scss" scoped>
.holder {
    max-width: 710px;
}
</style>